<template>
  <div class="slide">
    <Tooltip title="Velg kjønn" show="1">
      Det er ulike grenseverdier for kvinner og menn når det kommer til alkohol,
      siden biologi har innvirkning på hvordan alkoholen brytes ned. Testen blir
      mer nøyaktig hvis du oppgir kjønn.
    </Tooltip>
    <div class="grid-container genderSelection">
      <div class="grid-x">
        <div class="small-6 colums text-right">
          <input
            v-model="sex"
            id="genderFemale"
            name="gender"
            type="radio"
            value="female"
            class="ng-untouched ng-valid ng-dirty"
          /><label
            class="genderSelection--female text-center"
            for="genderFemale"
            ><span class="icon female block m--center"></span
            ><span>Kvinne</span></label
          >
        </div>
        <div class="small-6 colums text-left">
          <input
            v-model="sex"
            id="genderMale"
            name="gender"
            type="radio"
            value="male"
            class="ng-untouched ng-valid ng-dirty"
          /><label class="genderSelection--male text-center" for="genderMale"
            ><span class="icon male block m--center"></span
            ><span>Mann</span></label
          >
        </div>
        <div
          class="small-12 colums text-center flex--medium flex--center of--visible"
        >
          <input
            v-model="sex"
            class="mb--0 ng-untouched ng-valid ng-dirty"
            id="genderNone"
            name="gender"
            type="radio"
            value="none"
          /><label for="genderNone"
            ><span>Jeg ønsker ikke å svare </span>
            <div class="tooltip tooltip--small tooltip--top tooltip--center">
              <button
                class="js--tooltip js--tooltip--small js--tooltip--top js--tooltip--center tooltip__toggle js--tooltip__toggle"
                data-text="På grunn av biologiske forskjeller som har betydning for promillenivå, vil resultatet bli mer unøyaktig dersom du velger dette alternativet.
"
                data-toggle-tooltip="1"
              >
                ?</button
              ><span class="tooltip__popup" data-tooltip="1"
                ><button class="close js--tooltip__toggle"></button>På grunn av
                biologiske forskjeller som har betydning for promillenivå, vil
                resultatet bli mer unøyaktig dersom du velger dette
                alternativet.
              </span>
            </div></label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    sex: {
      get() {
        if (this.$store.state.sex == "") {
          this.$eventBus.$emit("allowNext", false);
        } else {
          this.$eventBus.$emit("allowNext", true);
        }
        return this.$store.state.sex;
      },
      set(value) {
        this.$store.commit("setSex", { sex: value });
      },
    },
  },
};
</script>
